<palantir-dialog title="Novidades do Flux Control">
  <div palantir-dialog-content class="palantir palantir-scrollbar flex flex-col gap-6 p-4">
    @for (post of displayPosts(); track post.id) {
      <div class="flex flex-col gap-2 rounded-xl border border-neutral-200 p-4">
        <div class="flex items-center gap-2">
          @for (tag of post.tags; track tag) {
            <palantir-text size="2xs" class="rounded-full border px-1 py-0.5" [class]="tag.classes">
              {{ tag.name }}
            </palantir-text>
          }

          @if (post.tags.length) {
            <palantir-text size="xs" class="text-neutral-500"> • </palantir-text>
          }

          <palantir-text size="xs" class="text-neutral-500">
            {{ post.dateModified | date: 'dd/MM/yyyy' }}
          </palantir-text>
        </div>

        <div
          class="blog-content prose prose-sm prose-neutral max-w-non"
          [innerHTML]="post.content"
        ></div>

        <a
          [href]="post.url"
          target="_blank"
          class="ml-auto mt-2 inline-flex w-fit items-center gap-1 rounded-md px-2 py-1 text-xs font-medium text-blue-600 hover:text-blue-700 hover:underline"
        >
          Continue lendo no blog
          <palantir-icon name="arrow-forward-outline"></palantir-icon>
        </a>
      </div>
    }
  </div>

  <div palantir-dialog-actions class="flex w-full justify-end border-t border-neutral-200 p-4">
    <palantir-button (click)="close()" variant="positive"> Entendi </palantir-button>
  </div>
</palantir-dialog>
